import { FC } from "react";
import { DescriptionContainer } from "./styles";
import { colors } from "../../../styles/colors";
import Typography from "../../../components/typography";

interface DescriptionProps {
  description: string;
}

const Description: FC<DescriptionProps> = ({ description }) => {
  return (
    <DescriptionContainer 
      mt={2.5} 
      mb={2.5}
      maxW={{ md: 54.688, xxs: "100%" }}
      padding={{ md: 3.125, sm: 2.5, xs: 2, xxs: 1.5 }}
    >
      <Typography
        fSize={{ md: 1.313, xxs: 1.125 }}
        lHeight={{ md: 2, xxs: 1.625 }}
        fWeight={400}
        color={colors.black}
        dangerouslySetInnerHTML={{ __html: description?.replace(/<p><\/p>/g, '<p>&nbsp;</p>') }}
      />
    </DescriptionContainer>
  );
};

export default Description;
